import { render, staticRenderFns } from "./FormViewFileList.vue?vue&type=template&id=2b4cdb65&scoped=true"
import script from "./FormViewFileList.vue?vue&type=script&lang=js"
export * from "./FormViewFileList.vue?vue&type=script&lang=js"
import style0 from "./FormViewFileList.vue?vue&type=style&index=0&id=2b4cdb65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cdb65",
  null
  
)

export default component.exports